import axios, { AxiosPromise } from 'axios';
import { IAddress } from '~/models/viaCep';

export default class ViaCepService {
  static getAddress(cep: string): AxiosPromise<IAddress> {
    return axios.get(`https://viacep.com.br/ws/${cep}/json/`);
  }
}
